'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    var tabWidth = this.props.children && this.props.children.length ? 100 / this.props.children.length + '%' : 'auto';

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            width: '100%',
            position: 'relative',
            textAlign: 'center',
            font: theme.tsNormal + '/' + theme.tlNormal + ' "' + theme.fontFamily + '"',
            background: theme.background,
            borderTop: '1px solid ' + theme.borderTopColor,
            borderLeft: '1px solid ' + theme.borderLeftColor,
            borderRight: '1px solid ' + theme.borderRightColor,
            zoom: 1,
            '&:after': {
                clear: 'both',
                content: '""',
                display: 'block',
                height: 0
            },

            '& >*': {
                textAlign: 'center',
                fontSize: theme.fontSize,
                lineHeight: theme.lineHeight,
                color: theme.color,
                position: 'relative',
                float: 'left',
                padding: theme.gutter / 2 + 'px ' + theme.gutter * 2 + 'px',
                transition: 'color ' + theme.transitionDuration + ' ' + theme.transitionFunction,
                borderBottom: '1px solid ' + theme.borderBottomColor,
                boxSizing: 'border-box',
                textWrap: 'none',
                whiteSpace: 'nowrap',
                wordWrap: 'normal',
                width: tabWidth,

                '&:not(:last-child)': {
                    borderRight: '1px solid ' + theme.borderRight
                },

                '&>div, &>span': {
                    display: 'inline-block',
                    verticalAlign: 'middle'
                },

                '&:hover': {
                    cursor: 'pointer',
                    color: theme.hoverColor,
                    borderBottomColor: theme.hoverBorderBottomColor
                },

                '&.active': {
                    cursor: 'pointer',
                    color: theme.activeColor,
                    borderBottomColor: theme.activeBorderBottomColor
                },

                '.content': {
                    position: 'relative',
                    backgroundColor: theme.contentBackground,
                    borderBottom: '1px solid ' + theme.contentBorderBottomColor,
                    borderLeft: '1px solid ' + theme.contentBorderLeftColor,
                    borderRight: '1px solid ' + theme.contentBorderRightColor
                }
            }
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var baseTheme = function baseTheme(theme) {
    return {
        background: theme.elPrimary,
        borderTopColor: theme.elDivider,
        borderLeftColor: theme.elDivider,
        borderRightColor: theme.elDivider,
        borderBottomColor: theme.elDivider,
        fontSize: theme.tsNormal,
        lineHeight: theme.tlNormal,
        color: theme.tLabel,

        hoverColor: theme.tInactive,
        hoverBorderBottomColor: theme.elPrimary,

        activeColor: theme.tInactive,
        activeBorderBottomColor: 'transparent',

        contentBackground: theme.elPrimary,
        contentBorderLeftColor: theme.elDivider,
        contentBorderRightColor: theme.elDivider,
        contentBorderBottomColor: theme.elDivider
    };
};